import type { FallbackProps } from 'react-error-boundary'
import { Button } from './ui'

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-swiss-white">
      <div className="w-full max-w-[400px] px-4 text-center">
        {/* Error Icon */}
        <div className="w-12 h-12 mx-auto mb-6 bg-swiss-red flex items-center justify-center">
          <span className="text-swiss-white font-bold text-[20px]">!</span>
        </div>

        {/* Error Title */}
        <h1 className="text-[18px] font-medium text-swiss-black mb-2">
          Something went wrong
        </h1>

        {/* Error Message */}
        <p className="text-[13px] text-swiss-gray-500 mb-6">
          {error instanceof Error ? error.message : 'An unexpected error occurred'}
        </p>

        {/* Error Details (collapsed by default) */}
        <details className="mb-6 text-left">
          <summary className="text-[11px] uppercase tracking-[0.1em] text-swiss-gray-500 cursor-pointer">
            Technical Details
          </summary>
          <pre className="mt-2 p-3 bg-swiss-off-white text-[12px] text-swiss-gray-700 overflow-auto max-h-[200px] font-mono">
            {error instanceof Error ? error.stack : String(error)}
          </pre>
        </details>

        {/* Reset Button */}
        <Button onClick={resetErrorBoundary} variant="primary">
          Try Again
        </Button>
      </div>
    </div>
  )
}
